const API = process.env.REACT_APP_BACKEND_URL;
const CONSENT_KEY = "medlyn-consent";

export const getConsent = () => localStorage.getItem(CONSENT_KEY);
export const setConsent = (value) => localStorage.setItem(CONSENT_KEY, value);

const sessionId = () => {
  let id = sessionStorage.getItem("medlyn-session");
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem("medlyn-session", id);
  }
  return id;
};

export const track = (type, data = {}) => {
  if (getConsent() !== "granted") return;
  const payload = JSON.stringify({
    type,
    path: window.location.pathname,
    name: data.name || "",
    referrer: document.referrer || "",
    session_id: sessionId(),
  });
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/api/analytics/event`, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(`${API}/api/analytics/event`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true });
    }
  } catch {}
};

export const trackPageview = () => track("pageview");
export const trackClick = (name) => track("click", { name });
